import { Modify } from "../utilities/modifyType";
import Asset from "./Asset";
import { toAssetCategory } from "./AssetCategory";
import { AssetDataType } from "./AssetType";
import { LibraryItem } from "./LibraryItem";
import { LibraryItemType } from "./LibraryItemType";

export interface FileAsset extends Asset {
    // Url to the file location for this asset.
    location: string;
    // File size
    size?: number;
    // File extension
    extension?: string;
    // File MIME type
    mimeType: string;
    
    assetType: AssetDataType;
}

export type SerializedFileAsset = Modify<FileAsset, {
    category: string,
    dateCreated: string;
    dateModified: string;
    dateAccessed: string;
    datePreached?: string;
    assetType: undefined;
}>

export function deserializeFileAsset(fileAsset:SerializedFileAsset): FileAsset {
    return {
        ...fileAsset,
        category: toAssetCategory(fileAsset.category),
        dateCreated: new Date(fileAsset.dateCreated),
        dateModified: new Date(fileAsset.dateModified),
        dateAccessed: new Date(fileAsset.dateAccessed),
        datePreached: fileAsset.datePreached ? new Date(fileAsset.datePreached) : undefined,
        assetType: AssetDataType.File
    }
}

export function convertFileAssetToLibraryItem(fileAsset: FileAsset): LibraryItem {
    return {
        ...fileAsset,
        type: LibraryItemType.FileAsset,
        isShared: false,
        isTemplate: false,
        templateDescription: "",
        slideExporterAspectRatio: "16x9",
        linkUrl: undefined,
        category: fileAsset.category
    }
}